<div id="bankverbindungAngaben">

  <div class="mb-5x">
    <h2 class="mb-2x">{{ 'COMMON_UI.FRAGEBOGEN.BANKVERBINDUNGEN.TITEL' | translate }}</h2>

    <div class="col-sm-12 col-lg-12 p-0 mb-3x">
      <common-ui-card [message]=" 'COMMON_UI.FRAGEBOGEN.BANKVERBINDUNGEN.INFO' | translate"
                      type="info">
      </common-ui-card>
    </div>

    <div class="mb-5x">
      <div class="d-flex justify-content-between mb-2x">
        <h5>{{ 'COMMON_UI.FRAGEBOGEN.BANKVERBINDUNGEN.PERSONENSTEUERN_TITEL' | translate }}</h5>
        <common-ui-daten-uebernahme (picked)="data.bankverbindungPersonensteuern = $event"
                                    [itemTemplate]="datenuebernahmeBankverbindung"
                                    [items]="stammdaten?.antragsteller?.bankverbindungen?.array" [readonly]="readonly"
                                    context="BankverbindungPersonensteuern"></common-ui-daten-uebernahme>
      </div>
      <common-ui-bankverbindung [(data)]="data.bankverbindungPersonensteuern"
                                [index]="0" [readonly]="readonly">
      </common-ui-bankverbindung>
    </div>

    <div class="mb-5x">
      <div class="d-flex justify-content-between mb-2x">
        <h5>{{ 'COMMON_UI.FRAGEBOGEN.BANKVERBINDUNGEN.BETRIEBSSTEUERN_TITEL' | translate }}</h5>
        <common-ui-daten-uebernahme (picked)="data.bankverbindungBetriebssteuern = $event"
                                    *ngIf="!data.betriebssteuernWiePersonensteuern"
                                    [itemTemplate]="datenuebernahmeBankverbindung"
                                    [items]="stammdaten?.unternehmen?.bankverbindungen?.array" [readonly]="readonly"
                                    context="BankverbindungBetriebssteuern"></common-ui-daten-uebernahme>
      </div>
      <div class="form-row mb-3x">
        <div class="col-sm-12 col-lg-12 d-flex common-ui-switch-parent">
          <common-ui-switch [(checked)]="data.betriebssteuernWiePersonensteuern"
                            (checkedChange)="clearBankInformation($event)"
                            [readonly]="readonly" id="switchBankverbindungBetriebssteuernWiePersonensteuern">
          </common-ui-switch>
          <p>{{ 'COMMON_UI.FRAGEBOGEN.BANKVERBINDUNGEN.BETRIEBSSTEUERN_WIE_PERSONENSTEUERN' | translate }}</p>
        </div>
      </div>

      <common-ui-bankverbindung *ngIf="!data?.betriebssteuernWiePersonensteuern" [(data)]="data.bankverbindungBetriebssteuern"
                                [index]="1" [readonly]="readonly">
      </common-ui-bankverbindung>
    </div>

  </div>

</div>

<ng-template #datenuebernahmeBankverbindung let-item="item">
  <h4 class="list-group-item-heading">{{item?.iban}}</h4>
  <div class="list-group-item-text">
    <p *ngIf="item?.bic">{{item?.bic}}</p>
    <p *ngIf="item?.abweichenderKontoinhaber">{{ 'COMMON_UI.BANKVERBINDUNG.ABWEICHENDER_KONTOINHABER' | translate }}:
      {{item?.abweichenderKontoinhaber}}</p>
    <p *ngIf="item?.bezeichnung">{{item?.bezeichnung}}</p>
  </div>
</ng-template>
